<div></div>
<div appZsLoader [isVisible]="true"></div><br><br><br>
<div class="zs-margin-2-0-0-0">
  <p class="zs-text-inverse zs-body-small zs-font-weight-semi-bold">
    {{loadingLabel}}...
  </p>
</div>
